import React from "react";

const svgStyle = { width: "100%", height: "100%", display: "block" };

export const ProductImages = {
  wheelchair: ({ accent = "#1f4d3d" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="wc-bg" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2a2a4a" />
          <stop offset="100%" stopColor="#0a0a1a" />
        </radialGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="3" result="coloredBlur" />
          <feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>
      <rect width="300" height="300" fill="url(#wc-bg)" />
      {/* Main wheel back */}
      <circle cx="80" cy="210" r="55" fill="none" stroke={accent} strokeWidth="8" opacity="0.9" filter="url(#glow)" />
      <circle cx="80" cy="210" r="42" fill="none" stroke={accent} strokeWidth="2" opacity="0.4" />
      <circle cx="80" cy="210" r="12" fill={accent} opacity="0.8" />
      {/* Spokes */}
      {[0,45,90,135,180,225,270,315].map((a,i) => (
        <line key={i} x1="80" y1="210"
          x2={80 + 42*Math.cos(a*Math.PI/180)}
          y2={210 + 42*Math.sin(a*Math.PI/180)}
          stroke={accent} strokeWidth="1.5" opacity="0.5" />
      ))}
      {/* Small front wheel */}
      <circle cx="200" cy="240" r="28" fill="none" stroke={accent} strokeWidth="6" opacity="0.9" filter="url(#glow)" />
      <circle cx="200" cy="240" r="8" fill={accent} opacity="0.7" />
      {[0,60,120,180,240,300].map((a,i) => (
        <line key={i} x1="200" y1="240"
          x2={200 + 20*Math.cos(a*Math.PI/180)}
          y2={240 + 20*Math.sin(a*Math.PI/180)}
          stroke={accent} strokeWidth="1.5" opacity="0.5" />
      ))}
      {/* Frame */}
      <polyline points="80,155 100,100 160,100 175,155 200,212" fill="none" stroke={accent} strokeWidth="5" strokeLinejoin="round" opacity="0.9" />
      <line x1="100" y1="100" x2="115" y2="60" stroke={accent} strokeWidth="4" opacity="0.8" />
      <line x1="160" y1="100" x2="175" y2="60" stroke={accent} strokeWidth="4" opacity="0.8" />
      {/* Seat */}
      <rect x="95" y="95" width="80" height="12" rx="4" fill={accent} opacity="0.9" />
      {/* Backrest */}
      <rect x="95" y="55" width="80" height="45" rx="6" fill="none" stroke={accent} strokeWidth="4" opacity="0.6" />
      <rect x="95" y="55" width="80" height="45" rx="6" fill={accent} opacity="0.08" />
      {/* Footrest */}
      <line x1="160" y1="155" x2="185" y2="175" stroke={accent} strokeWidth="4" opacity="0.7" />
      <rect x="182" y="172" width="30" height="8" rx="3" fill={accent} opacity="0.7" />
      {/* Motor indicator */}
      <circle cx="240" cy="110" r="18" fill="none" stroke={accent} strokeWidth="2" opacity="0.5" />
      <text x="240" y="115" textAnchor="middle" fill={accent} fontSize="10" opacity="0.8">⚡</text>
      {/* Light effects */}
      <circle cx="150" cy="150" r="80" fill={accent} opacity="0.03" />
    </svg>
  ),

  cgm: ({ accent = "#a8edea" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="cgm-bg" cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#1a2a2a" />
          <stop offset="100%" stopColor="#080f10" />
        </radialGradient>
      </defs>
      <rect width="300" height="300" fill="url(#cgm-bg)" />
      {/* Sensor device body */}
      <rect x="95" y="80" width="110" height="140" rx="20" fill="#1a2e2e" stroke={accent} strokeWidth="2" opacity="0.9" />
      <rect x="100" y="85" width="100" height="130" rx="17" fill="#0d1f1f" />
      {/* Screen */}
      <rect x="108" y="95" width="84" height="60" rx="6" fill="#0a1515" stroke={accent} strokeWidth="1" opacity="0.7" />
      {/* Glucose reading */}
      <text x="150" y="130" textAnchor="middle" fill={accent} fontSize="28" fontWeight="bold" fontFamily="monospace">97</text>
      <text x="150" y="148" textAnchor="middle" fill={accent} fontSize="9" opacity="0.6">mg/dL</text>
      {/* Trend line */}
      <polyline points="115,170 130,165 145,168 160,158 175,155 185,150" fill="none" stroke={accent} strokeWidth="2" opacity="0.8" />
      <circle cx="185" cy="150" r="3" fill={accent} />
      {/* Sensor needle */}
      <ellipse cx="150" cy="230" rx="20" ry="8" fill={accent} opacity="0.3" />
      <rect x="147" y="215" width="6" height="25" rx="3" fill={accent} opacity="0.6" />
      {/* Signal waves */}
      {[1,2,3].map(i => (
        <circle key={i} cx="240" cy="80" r={i*12} fill="none" stroke={accent} strokeWidth="1" opacity={0.3/i} />
      ))}
      <circle cx="240" cy="80" r="5" fill={accent} opacity="0.8" />
      {/* Bluetooth */}
      <text x="240" y="160" textAnchor="middle" fill={accent} fontSize="22" opacity="0.5">⟡</text>
    </svg>
  ),

  hearing: ({ accent = "#1f4d3d" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="ha-bg" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2a200a" />
          <stop offset="100%" stopColor="#0f0a02" />
        </radialGradient>
      </defs>
      <rect width="300" height="300" fill="url(#ha-bg)" />
      {/* BTE device body */}
      <path d="M130,80 Q120,80 115,95 L110,180 Q110,195 125,195 L145,195 Q160,195 160,180 L155,95 Q150,80 140,80 Z" fill="#1a1505" stroke={accent} strokeWidth="2" />
      <path d="M132,82 Q122,82 118,96 L113,178 Q113,192 126,192 L144,192 Q157,192 157,178 L152,96 Q148,82 138,82 Z" fill="#241e08" />
      {/* Microphone */}
      <circle cx="135" cy="98" r="8" fill={accent} opacity="0.3" />
      <circle cx="135" cy="98" r="4" fill={accent} opacity="0.8" />
      {/* Volume indicator */}
      <rect x="125" y="115" width="20" height="3" rx="1.5" fill={accent} opacity="0.3" />
      <rect x="125" y="115" width="14" height="3" rx="1.5" fill={accent} opacity="0.8" />
      {/* Speaker dome */}
      <ellipse cx="135" cy="185" rx="14" ry="10" fill={accent} opacity="0.2" stroke={accent} strokeWidth="1.5" />
      {/* Thin wire */}
      <path d="M135,193 Q140,220 160,240 Q175,255 185,260" fill="none" stroke={accent} strokeWidth="2" opacity="0.6" />
      {/* Ear bud */}
      <circle cx="185" cy="260" r="12" fill="#241e08" stroke={accent} strokeWidth="2" />
      <circle cx="185" cy="260" r="6" fill={accent} opacity="0.4" />
      {/* Sound waves */}
      {[20,35,50].map((r,i) => (
        <path key={i} d={`M220,120 Q235,${120-r/3},235,135 Q235,${150+r/3},220,150`} fill="none" stroke={accent} strokeWidth="1.5" opacity={0.6-i*0.15} />
      ))}
      {/* AI chip glow */}
      <rect x="220" y="200" width="50" height="30" rx="5" fill={accent} opacity="0.08" stroke={accent} strokeWidth="1" />
      <text x="245" y="220" textAnchor="middle" fill={accent} fontSize="8" opacity="0.7">AI CHIP</text>
    </svg>
  ),

  cpap: ({ accent = "#66c0f4" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="cpap-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0a1520" />
          <stop offset="100%" stopColor="#051015" />
        </linearGradient>
      </defs>
      <rect width="300" height="300" fill="url(#cpap-bg)" />
      {/* Machine body */}
      <rect x="50" y="120" width="160" height="100" rx="15" fill="#0f2030" stroke={accent} strokeWidth="2" />
      <rect x="55" y="125" width="150" height="90" rx="12" fill="#0a1a28" />
      {/* Display screen */}
      <rect x="65" y="133" width="80" height="50" rx="5" fill="#050f18" stroke={accent} strokeWidth="1" opacity="0.8" />
      <text x="105" y="158" textAnchor="middle" fill={accent} fontSize="16" fontFamily="monospace">8.2</text>
      <text x="105" y="172" textAnchor="middle" fill={accent} fontSize="8" opacity="0.6">cmH₂O</text>
      {/* Buttons */}
      <circle cx="175" cy="148" r="10" fill={accent} opacity="0.2" stroke={accent} strokeWidth="1.5" />
      <circle cx="175" cy="148" r="4" fill={accent} opacity="0.8" />
      <circle cx="195" cy="148" r="7" fill={accent} opacity="0.1" stroke={accent} strokeWidth="1" />
      <circle cx="195" cy="165" r="7" fill={accent} opacity="0.1" stroke={accent} strokeWidth="1" />
      {/* Hose connector */}
      <rect x="185" y="195" width="30" height="15" rx="5" fill={accent} opacity="0.4" />
      {/* Hose */}
      <path d="M215,202 Q240,202 245,220 Q250,238 235,250" fill="none" stroke={accent} strokeWidth="8" strokeLinecap="round" opacity="0.3" />
      <path d="M215,202 Q240,202 245,220 Q250,238 235,250" fill="none" stroke={accent} strokeWidth="4" strokeLinecap="round" opacity="0.5" strokeDasharray="8,4" />
      {/* Mask */}
      <path d="M210,250 Q225,238 240,250 Q250,262 225,272 Q200,262 210,250Z" fill={accent} opacity="0.15" stroke={accent} strokeWidth="1.5" />
      {/* Humidity water drop */}
      <text x="60" y="240" fill={accent} fontSize="20" opacity="0.4">💧</text>
      {/* ZZZ sleep indicator */}
      <text x="250" y="100" fill={accent} fontSize="14" opacity="0.3">Z</text>
      <text x="260" y="85" fill={accent} fontSize="18" opacity="0.2">Z</text>
      <text x="245" y="70" fill={accent} fontSize="22" opacity="0.15">Z</text>
    </svg>
  ),

  bed: ({ accent = "#5b9bd5" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="bed-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1a0f05" />
          <stop offset="100%" stopColor="#0d0702" />
        </linearGradient>
      </defs>
      <rect width="300" height="300" fill="url(#bed-bg)" />
      {/* Bed frame */}
      <rect x="30" y="160" width="240" height="80" rx="8" fill="#1a1005" stroke={accent} strokeWidth="2" />
      {/* Mattress */}
      <rect x="35" y="150" width="230" height="60" rx="10" fill="#221508" stroke={accent} strokeWidth="1.5" opacity="0.9" />
      {/* Pillow */}
      <rect x="200" y="143" width="60" height="40" rx="12" fill="#2a1a08" stroke={accent} strokeWidth="1" opacity="0.8" />
      {/* Headboard (elevated) */}
      <rect x="30" y="80" width="30" height="90" rx="5" fill="#1a1005" stroke={accent} strokeWidth="2" />
      <rect x="32" y="82" width="26" height="86" rx="4" fill="#221508" />
      {/* Footboard */}
      <rect x="240" y="120" width="30" height="50" rx="5" fill="#1a1005" stroke={accent} strokeWidth="2" />
      {/* Legs with wheels */}
      {[50,240].map((x,i) => (
        <g key={i}>
          <rect x={x} y="238" width="12" height="30" rx="3" fill={accent} opacity="0.5" />
          <circle cx={x+6} cy="272" r="8" fill="none" stroke={accent} strokeWidth="2" opacity="0.7" />
          <circle cx={x+6} cy="272" r="3" fill={accent} opacity="0.5" />
        </g>
      ))}
      {/* Control panel */}
      <rect x="90" y="218" width="80" height="20" rx="5" fill={accent} opacity="0.15" stroke={accent} strokeWidth="1" />
      <text x="130" y="232" textAnchor="middle" fill={accent} fontSize="8" opacity="0.7">BED CONTROL</text>
      {/* Tilt indicator arrows */}
      <path d="M50,115 L45,100 L55,100 Z" fill={accent} opacity="0.6" />
      <path d="M50,90 L45,75 L55,75 Z" fill={accent} opacity="0.4" />
      {/* Safety rail */}
      <rect x="100" y="138" width="80" height="8" rx="3" fill={accent} opacity="0.4" stroke={accent} strokeWidth="1" />
      <line x1="120" y1="138" x2="120" y2="162" stroke={accent} strokeWidth="2" opacity="0.4" />
      <line x1="155" y1="138" x2="155" y2="162" stroke={accent} strokeWidth="2" opacity="0.4" />
    </svg>
  ),

  watch: ({ accent = "#e040fb" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="w-bg" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#1a0520" />
          <stop offset="100%" stopColor="#080210" />
        </radialGradient>
      </defs>
      <rect width="300" height="300" fill="url(#w-bg)" />
      {/* Watch band top */}
      <rect x="120" y="50" width="60" height="50" rx="8" fill="#1a0a1f" stroke={accent} strokeWidth="1.5" opacity="0.7" />
      {/* Watch body */}
      <rect x="90" y="95" width="120" height="110" rx="22" fill="#120318" stroke={accent} strokeWidth="2.5" />
      <rect x="95" y="100" width="110" height="100" rx="19" fill="#0a0215" />
      {/* Screen */}
      <rect x="100" y="108" width="100" height="84" rx="15" fill="#070012" stroke={accent} strokeWidth="1" opacity="0.5" />
      {/* GPS icon */}
      <circle cx="150" cy="130" r="15" fill="none" stroke={accent} strokeWidth="1.5" opacity="0.5" />
      <path d="M150,118 L145,128 L150,125 L155,128 Z" fill={accent} opacity="0.8" />
      {/* Location pulse */}
      {[1,2].map(i => (
        <circle key={i} cx="150" cy="130" r={i*10+15} fill="none" stroke={accent} strokeWidth="1" opacity={0.3/i} />
      ))}
      {/* Heart rate */}
      <polyline points="108,160 118,160 123,150 128,170 133,155 138,163 148,163" fill="none" stroke={accent} strokeWidth="2" opacity="0.8" />
      {/* Time */}
      <text x="150" y="185" textAnchor="middle" fill={accent} fontSize="11" fontFamily="monospace" opacity="0.7">GPS ACTIVE</text>
      {/* Band bottom */}
      <rect x="120" y="200" width="60" height="50" rx="8" fill="#1a0a1f" stroke={accent} strokeWidth="1.5" opacity="0.7" />
      {/* Crown button */}
      <rect x="210" y="140" width="8" height="20" rx="3" fill={accent} opacity="0.5" />
    </svg>
  ),

  hearing2: ({ accent = "#85c1e9" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <rect width="300" height="300" fill="#080c10" />
      <path d="M140,70 Q120,70 112,90 L108,190 Q108,208 128,208 L152,208 Q172,208 172,190 L168,90 Q160,70 140,70 Z" fill="#0d1a22" stroke={accent} strokeWidth="2" />
      <circle cx="140" cy="88" r="10" fill={accent} opacity="0.4" />
      <circle cx="140" cy="88" r="5" fill={accent} opacity="0.9" />
      <rect x="128" y="108" width="24" height="4" rx="2" fill={accent} opacity="0.3" />
      <rect x="128" y="108" width="18" height="4" rx="2" fill={accent} opacity="0.7" />
      <ellipse cx="140" cy="198" rx="16" ry="10" fill={accent} opacity="0.2" stroke={accent} strokeWidth="1.5" />
      <path d="M140,206 Q145,230 162,245" fill="none" stroke={accent} strokeWidth="2" opacity="0.5" />
      <circle cx="162" cy="248" r="11" fill="#0d1a22" stroke={accent} strokeWidth="2" />
      <circle cx="162" cy="248" r="5" fill={accent} opacity="0.5" />
      {[18,30,42].map((r,i) => (
        <path key={i} d={`M205,110 Q218,${110-r/3},218,125 Q218,${140+r/3},205,140`} fill="none" stroke={accent} strokeWidth="1.5" opacity={0.5-i*0.1} />
      ))}
    </svg>
  ),

  bp: ({ accent = "#3d6b58" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <rect width="300" height="300" fill="#080508" />
      {/* Device body */}
      <rect x="70" y="90" width="160" height="120" rx="12" fill="#120f05" stroke={accent} strokeWidth="2" />
      <rect x="75" y="95" width="150" height="110" rx="10" fill="#0d0b03" />
      {/* Display */}
      <rect x="82" y="102" width="100" height="65" rx="5" fill="#060503" stroke={accent} strokeWidth="1" opacity="0.7" />
      <text x="132" y="128" textAnchor="middle" fill={accent} fontSize="20" fontFamily="monospace">120</text>
      <text x="132" y="148" textAnchor="middle" fill={accent} fontSize="14" fontFamily="monospace">80</text>
      <text x="132" y="160" textAnchor="middle" fill={accent} fontSize="7" opacity="0.5">mmHg</text>
      {/* Buttons */}
      <circle cx="205" cy="132" r="12" fill={accent} opacity="0.15" stroke={accent} strokeWidth="1.5" />
      <text x="205" y="136" textAnchor="middle" fill={accent} fontSize="10" opacity="0.8">▶</text>
      {/* Cuff */}
      <path d="M80,215 Q150,185 220,215 L220,260 Q150,240 80,260 Z" fill="#1a1505" stroke={accent} strokeWidth="2" opacity="0.8" />
      <path d="M80,215 Q150,195 220,215" fill="none" stroke={accent} strokeWidth="1.5" opacity="0.5" strokeDasharray="5,3" />
      {/* Tube */}
      <path d="M150,210 L150,205" stroke={accent} strokeWidth="4" strokeLinecap="round" opacity="0.6" />
      {/* WHO indicator */}
      <rect x="190" y="170" width="40" height="15" rx="3" fill="#0a2010" stroke="#4caf50" strokeWidth="1" />
      <text x="210" y="181" textAnchor="middle" fill="#4caf50" fontSize="7">NORMAL</text>
    </svg>
  ),

  nebulizer: ({ accent = "#76d7c4" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <rect width="300" height="300" fill="#05100f" />
      {/* Base unit */}
      <rect x="90" y="150" width="120" height="80" rx="10" fill="#0a1f1d" stroke={accent} strokeWidth="2" />
      {/* Mesh chamber */}
      <ellipse cx="150" cy="150" rx="40" ry="55" fill="#0d2523" stroke={accent} strokeWidth="2" />
      <ellipse cx="150" cy="150" rx="33" ry="48" fill="#0a1f1d" opacity="0.8" />
      {/* Mesh pattern */}
      {[130,140,150,160,170].map((x,i) => (
        <line key={i} x1={x} y1="103" x2={x} y2="197" stroke={accent} strokeWidth="0.8" opacity="0.25" />
      ))}
      {[110,122,134,146,158,170,182,194].map((y,i) => (
        <line key={i} x1="110" y1={y} x2="190" y2={y} stroke={accent} strokeWidth="0.8" opacity="0.25" />
      ))}
      {/* Mist particles */}
      {[[155,88],[145,82],[163,78],[150,75],[140,85]].map(([x,y],i) => (
        <circle key={i} cx={x} cy={y} r={2+i*0.5} fill={accent} opacity={0.4-i*0.06} />
      ))}
      {/* USB port */}
      <rect x="135" y="220" width="30" height="8" rx="2" fill={accent} opacity="0.3" stroke={accent} strokeWidth="1" />
      <text x="150" y="227" textAnchor="middle" fill={accent} fontSize="5" opacity="0.6">USB-C</text>
      {/* Tube */}
      <path d="M110,155 Q70,155 60,180 Q50,205 70,220" fill="none" stroke={accent} strokeWidth="5" strokeLinecap="round" opacity="0.4" />
      {/* Mask connector */}
      <path d="M70,220 Q65,232 80,240 Q95,248 80,256" fill="none" stroke={accent} strokeWidth="3" opacity="0.5" />
      <ellipse cx="75" cy="258" rx="15" ry="10" fill="none" stroke={accent} strokeWidth="2" opacity="0.5" />
    </svg>
  ),

  rollator: ({ accent = "#a9cce3" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <rect width="300" height="300" fill="#080c10" />
      {/* Frame sides */}
      <line x1="80" y1="80" x2="80" y2="220" stroke={accent} strokeWidth="6" strokeLinecap="round" opacity="0.8" />
      <line x1="220" y1="80" x2="220" y2="220" stroke={accent} strokeWidth="6" strokeLinecap="round" opacity="0.8" />
      {/* Handlebars */}
      <rect x="65" y="72" width="30" height="16" rx="8" fill={accent} opacity="0.8" />
      <rect x="205" y="72" width="30" height="16" rx="8" fill={accent} opacity="0.8" />
      {/* Cross braces */}
      <line x1="80" y1="120" x2="220" y2="120" stroke={accent} strokeWidth="4" opacity="0.6" />
      <line x1="80" y1="160" x2="220" y2="160" stroke={accent} strokeWidth="3" opacity="0.4" />
      {/* Seat */}
      <rect x="70" y="155" width="160" height="12" rx="6" fill={accent} opacity="0.3" stroke={accent} strokeWidth="1.5" />
      {/* Wheels */}
      {[80, 220].map((x, i) => (
        <g key={i}>
          <circle cx={x} cy="232" r="22" fill="none" stroke={accent} strokeWidth="5" opacity="0.8" />
          <circle cx={x} cy="232" r="8" fill={accent} opacity="0.5" />
          {[0,60,120,180,240,300].map((a,j) => (
            <line key={j} x1={x} y1="232"
              x2={x + 14*Math.cos(a*Math.PI/180)}
              y2={232 + 14*Math.sin(a*Math.PI/180)}
              stroke={accent} strokeWidth="1.5" opacity="0.4" />
          ))}
        </g>
      ))}
      {/* Brake cables */}
      <path d="M80,88 Q80,110 80,120" stroke={accent} strokeWidth="1.5" fill="none" opacity="0.4" strokeDasharray="4,3" />
      <path d="M220,88 Q220,110 220,120" stroke={accent} strokeWidth="1.5" fill="none" opacity="0.4" strokeDasharray="4,3" />
      {/* Storage pouch */}
      <rect x="110" y="125" width="80" height="30" rx="5" fill={accent} opacity="0.08" stroke={accent} strokeWidth="1" />
    </svg>
  ),

  shower: ({ accent = "#a8d8b9" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <rect width="300" height="300" fill="#050d08" />
      {/* Chair frame */}
      <rect x="90" y="160" width="120" height="8" rx="4" fill={accent} opacity="0.7" />
      {/* Chair legs */}
      {[100,195].map((x,i) => (
        <g key={i}>
          <rect x={x} y="168" width="8" height="60" rx="3" fill={accent} opacity="0.6" />
          <ellipse cx={x+4} cy="232" rx="12" ry="5" fill="none" stroke={accent} strokeWidth="2" opacity="0.5" />
        </g>
      ))}
      {/* Backrest */}
      <rect x="85" y="100" width="10" height="65" rx="4" fill={accent} opacity="0.6" />
      <rect x="85" y="100" width="130" height="10" rx="4" fill={accent} opacity="0.4" />
      <rect x="205" y="100" width="10" height="65" rx="4" fill={accent} opacity="0.6" />
      {/* Seat cushion */}
      <rect x="87" y="153" width="126" height="14" rx="5" fill={accent} opacity="0.2" stroke={accent} strokeWidth="1.5" />
      {/* Non-slip mat */}
      <rect x="50" y="245" width="200" height="30" rx="5" fill={accent} opacity="0.1" stroke={accent} strokeWidth="1.5" />
      {/* Mat texture */}
      {[65,85,105,125,145,165,185,205,225].map((x,i) => (
        <line key={i} x1={x} y1="245" x2={x} y2="275" stroke={accent} strokeWidth="1" opacity="0.2" />
      ))}
      <text x="150" y="264" textAnchor="middle" fill={accent} fontSize="8" opacity="0.5">NON-SLIP MAT</text>
      {/* Grab bar */}
      <rect x="50" y="130" width="20" height="80" rx="8" fill={accent} opacity="0.3" stroke={accent} strokeWidth="2" />
      <rect x="55" y="135" width="10" height="70" rx="5" fill={accent} opacity="0.2" />
      {/* Water drops */}
      {[[240,60],[255,40],[230,45],[248,75],[265,55]].map(([x,y],i) => (
        <path key={i} d={`M${x},${y} Q${x-4},${y+8} ${x},${y+12} Q${x+4},${y+8} ${x},${y}`} fill={accent} opacity={0.3+i*0.05} />
      ))}
    </svg>
  ),

  carecort: ({ accent = "#4fc3f7" }) => (
    <svg viewBox="0 0 300 300" style={svgStyle} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="cc-bg" cx="50%" cy="50%" r="60%">
          <stop offset="0%" stopColor="#041520" />
          <stop offset="100%" stopColor="#020810" />
        </radialGradient>
      </defs>
      <rect width="300" height="300" fill="url(#cc-bg)" />
      {/* Elegant device */}
      <rect x="80" y="60" width="140" height="200" rx="25" fill="#07192a" stroke={accent} strokeWidth="2" />
      <rect x="85" y="65" width="130" height="190" rx="22" fill="#051220" />
      {/* Screen */}
      <rect x="92" y="75" width="116" height="130" rx="10" fill="#030d18" stroke={accent} strokeWidth="1" opacity="0.6" />
      {/* Cross vital sign */}
      <path d="M120,120 L120,110 L130,110 L130,100 L140,100 L140,110 L150,110 L150,120 L160,120 L160,130 L150,130 L150,140 L140,140 L140,130 L130,130 L130,120 Z"
        fill="none" stroke={accent} strokeWidth="2" opacity="0.7" />
      {/* ECG line */}
      <polyline points="95,165 108,165 113,150 118,180 124,145 130,170 140,170 148,165 160,165 168,155 175,175 185,165 196,165"
        fill="none" stroke={accent} strokeWidth="1.8" opacity="0.9" />
      {/* SpO2 */}
      <text x="150" y="215" textAnchor="middle" fill={accent} fontSize="9" opacity="0.6">SpO₂ • ECG • TEMP</text>
      {/* Bottom controls */}
      <circle cx="150" cy="240" r="10" fill={accent} opacity="0.2" stroke={accent} strokeWidth="1.5" />
      <rect x="115" y="247" width="20" height="5" rx="2" fill={accent} opacity="0.2" />
      <rect x="165" y="247" width="20" height="5" rx="2" fill={accent} opacity="0.2" />
      {/* Glow effect */}
      <ellipse cx="150" cy="140" rx="50" ry="50" fill={accent} opacity="0.04" />
    </svg>
  ),
};
